module.exports = "pegasus/assets/theme5/small/1.jpg";